import { jsx } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import { dateButtonDisabled, dateButtonCompact, dateButton } from "./DateButton.css.mjs";
const DateButtonDisabled = ({
  isCompact = false,
  children
}) => /* @__PURE__ */ jsx(
  Box,
  {
    display: "block",
    position: "relative",
    marginY: "xxsmall",
    style: { paddingLeft: isCompact ? "4px" : "6px" },
    children: /* @__PURE__ */ jsx(
      Box,
      {
        className: [
          dateButtonDisabled,
          isCompact ? dateButtonCompact : dateButton
        ],
        component: "button",
        disabled: true,
        outline: "none",
        children: /* @__PURE__ */ jsx(Text, { size: isCompact ? "xsmall" : "small", tone: "secondary", children })
      }
    )
  }
);
export {
  DateButtonDisabled
};
